
const Flag = ({ image, isSelected, ...props }: any) => (
    <img alt="flag" src={image} width="30" height="30" className={(isSelected ? 'flag selected' : 'flag') +" clickable"} {...props} />
)

export default Flag